export default (source, order, key) => {
  const copySource = [...source];

  copySource.sort((a, b) => {
    const key1 = a[key];
    const key2 = b[key];

    if (order.indexOf(key1) > order.indexOf(key2)) {
      return 1;
    }

    return -1;
  });

  return copySource;
};
